import { render, staticRenderFns } from "./postForm.vue?vue&type=template&id=45eb31eb&scoped=true"
import script from "./postForm.vue?vue&type=script&lang=js"
export * from "./postForm.vue?vue&type=script&lang=js"
import style0 from "./postForm.vue?vue&type=style&index=0&id=45eb31eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45eb31eb",
  null
  
)

export default component.exports